import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
/*
 * transforma true e false em sim ou não
*/
@Pipe({name: 'dataPipe'})
export class DataPipe implements PipeTransform {
  transform(value:any, args:string[]):any {
      if (value) {
          let valor:string = value;
          if(valor.length > 10){
            return valor.substring(0,10);
          }else{
            return valor;
          }
      }
  }
}
